export default __webpack_public_path__ + "static/crm-features-list-3--e362093677f128592a17a5e89ca61e10.png";